import { bootstrap } from "@erp/shared/bootstrap";
import { PION_ERP_INFO } from "./const/erp-info.const";
import App from "./App.vue";
bootstrap({
    erpInfo: PION_ERP_INFO,
    routerImport: () => import("./router/index"),
    App,
});
